module.exports = __webpack_public_path__ + "static/media/scottish_widows.3ed4dffe.png";